/*!
 * Roundway gamified popup — "tap the spot" A/B test.
 *
 *  Variant A  GAME_PARASITE  — "Tap where parasites actually settle."  -> Wormwood
 *  Variant B  GAME_IMMUNE    — "Tap where most of your immune system lives." -> Core Biotic
 *
 * Self-contained. Config:
 *   <script src="...roundway-popup-game.js"
 *           data-api-base="https://xxx.supabase.co/functions/v1"
 *           data-anon-key="..."
 *           data-variant="auto|A|B"
 *           data-delay="6000"
 *           data-discount-code="CODE"
 *           data-discount-label="10% off your first order"></script>
 * Events -> popup-event (view / submit / dismiss) with variant = GAME_PARASITE|GAME_IMMUNE,
 * plus behavr-event quiz_choice so the bandit sees which spot they tapped.
 */
(function () {
  'use strict';
  // ── RETIRED FOR GOOD (2026-09-18) ── 2.2% vs the original popup's 6-12%.
  window.__RW_POPUP_GAME__ = true;
  return;
  /* eslint-disable no-unreachable */
  if (window.__RW_POPUP_GAME__) return;
  // Never run on lead-capture pages (Aquafibre/GLP-1 form, health quiz).
  try {
    if (window.__RW_BLOCK_POPUPS__ || /^\/pages\/(glp1|glp1-terms|quiz|health-quiz)(\/|$)/i.test(location.pathname)) return;
  } catch (_) {}
  window.__RW_POPUP_GAME__ = true;


  var POPUP_ID = 'gamified-tap';
  var SEEN_KEY = 'rw_game_popup_state';
  var COOLDOWN_DAYS = 14;

  // Persistent teaser state — the bottom-left "Pin the spot" pill that stays
  // visible whenever the popup is closed so visitors can always re-open it.
  var teaserEl = null;
  var currentRoot = null;
  var currentVariant = null;

  /* ---------------- config ---------------- */
  var cfg = window.RoundwayPopupGameConfig || {};
  (function () {
    var s = document.currentScript;
    if (!s) {
      var all = document.getElementsByTagName('script');
      for (var i = all.length - 1; i >= 0; i--) {
        if (all[i].src && /roundway-popup-game\.js/.test(all[i].src)) { s = all[i]; break; }
      }
    }
    if (s) {
      cfg.apiBase = cfg.apiBase || s.getAttribute('data-api-base') || '';
      cfg.anonKey = cfg.anonKey || s.getAttribute('data-anon-key') || '';
      cfg.variant = cfg.variant || s.getAttribute('data-variant') || 'auto';
      cfg.delay = cfg.delay || parseInt(s.getAttribute('data-delay') || '6000', 10);
      cfg.image = cfg.image || s.getAttribute('data-image') || '';
      cfg.discountCode = cfg.discountCode || s.getAttribute('data-discount-code') || '';
      cfg.discountLabel = cfg.discountLabel || s.getAttribute('data-discount-label') || '';
      cfg.discountNum = cfg.discountNum || s.getAttribute('data-discount-num') || '';

    }
  })();
  cfg.variant = cfg.variant || 'auto';
  cfg.delay = isNaN(cfg.delay) ? 6000 : cfg.delay;
  cfg.discountCode = cfg.discountCode || '';
  /* The code is never shipped in the page; it is returned after a valid sign-up. */
  function rwReveal(root, email) {
    if (!cfg.apiBase) return Promise.resolve();
    return fetch(cfg.apiBase + '/popup-reveal-code', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', apikey: cfg.anonKey || '', Authorization: 'Bearer ' + (cfg.anonKey || '') },
      body: JSON.stringify({ email: email, brand: 'roundway', source: 'popup-game' })
    }).then(function (r) { return r.json(); }).then(function (j) {
      if (!j || !j.code) return;
      cfg.discountCode = j.code;
      // Mystery tier (10/15/20) from popup-reveal-code; shared with the announcement bar so there is only ever one code.
      if (j.pct) root.querySelectorAll('[data-rw-pct]').forEach(function (el) { el.textContent = j.pct + '%'; });
      try { localStorage.setItem('rw_mystery', JSON.stringify({ code: j.code, pct: j.pct || null, expires_at: j.expires_at || null })); } catch (_) {}
      root.querySelectorAll('[data-code]').forEach(function (b) {
        b.setAttribute('data-code', j.code);
        var st = b.parentNode && b.parentNode.querySelector('strong');
        if (st) st.textContent = j.code;
      });
      root.querySelectorAll('a[href*="/discount/"]').forEach(function (a) {
        a.setAttribute('href', a.getAttribute('href').replace(/\/discount\/[^?]*/, '/discount/' + encodeURIComponent(j.code)));
      });
    }).catch(function () {});
  }

  cfg.discountLabel = cfg.discountLabel || 'your mystery code';
  cfg.discountNum = cfg.discountNum || '?';

  /* ---------------- variants ---------------- */
  var VARIANTS = {
    A: {
      key: 'GAME_PARASITE',
      title: 'Tap where parasites actually settle.',
      sub: 'one click. Most people get this wrong.',
      hint: 'Pick the spot you think is right',
      correct: 'intestine',
      spots: [
        { id: 'liver', label: 'Liver', at: [36, 41], side: 'left' },
        { id: 'stomach', label: 'Stomach', at: [59, 45], side: 'right' },
        { id: 'colon', label: 'Large intestine', at: [68, 54], side: 'left' },
        { id: 'intestine', label: 'Small intestine', at: [52, 70], side: 'left' }
      ],




      verdictWrong: 'You guessed the stomach. They don\u2019t.',
      verdictRight: 'Right \u2014 and almost nobody gets this one.',
      verdictOther: 'Close, but no. It\u2019s the intestine.',
      fact: 'Acid kills most of what you swallow. What survives settles in the intestine wall, which is where the bloating starts.',
      source: 'UKHSA: intestinal parasite infections are reported in the UK every year, most commonly picked up from food, water, pets and travel.',
      stat: { big: '1 in 3', small: 'UK adults report regular bloating or irregular stools (Guts UK, 2023)' },
      formLabel: 'Send my code to',
      cta: 'Reveal my mystery code<span aria-hidden="true">\u2192</span>',
       doneTitle: 'You\u2019re in',
      skip: 'No thanks, I\u2019ll guess again another time',
      tags: ['popup-game-parasite', 'lc:interest-wormwood']
    },
    B: {
      key: 'GAME_IMMUNE',
      title: 'Tap where your last course of antibiotics did the damage.',
      sub: 'one click. It is not where the infection was.',
      hint: 'Pick the spot you think is right',
      correct: 'gut',
      spots: [
        { id: 'liver', label: 'Liver', at: [36, 41], side: 'left' },
        { id: 'stomach', label: 'Stomach', at: [59, 45], side: 'right' },
        { id: 'colon', label: 'Large intestine', at: [68, 54], side: 'left' },
        { id: 'gut', label: 'Gut lining', at: [52, 70], side: 'left' }
      ],

      verdictWrong: 'You picked the stomach. The damage is further down.',
      verdictRight: 'Right, and that is why you felt off for weeks after.',


      verdictOther: 'Not quite. It happens in your gut lining.',
      fact: 'Antibiotics do not aim. They clear the good bacteria in your gut lining too, which is why you felt off for months.',
      source: 'Gut-associated lymphoid tissue holds roughly 70% of the body\u2019s immune cells (British Society for Immunology).',
      stat: { big: '70%', small: 'of your immune cells live in the gut lining, not the bloodstream' },
      formLabel: 'Send my code to',

      cta: 'Reveal my mystery code<span aria-hidden="true">\u2192</span>',
       doneTitle: 'You\u2019re in',
      skip: 'No thanks, close this',
      tags: ['popup-game-immune', 'lc:interest-corebiotic']
    }
  };

  /* ---------------- state helpers ---------------- */
  function readState() {
    try { return JSON.parse(localStorage.getItem(SEEN_KEY) || '{}') || {}; } catch (_) { return {}; }
  }
  function writeState(patch) {
    var s = readState();
    for (var k in patch) s[k] = patch[k];
    try { localStorage.setItem(SEEN_KEY, JSON.stringify(s)); } catch (_) {}
  }
  function sessionId() {
    try {
      if (window.RoundwayBandit && window.RoundwayBandit.sessionId) return window.RoundwayBandit.sessionId;
      var v = sessionStorage.getItem('rw_session_id');
      if (!v) {
        v = (window.crypto && crypto.randomUUID) ? crypto.randomUUID()
          : 'rwg-' + Math.random().toString(36).slice(2) + Date.now().toString(36);
        sessionStorage.setItem('rw_session_id', v);
      }
      return v;
    } catch (_) { return 'rwg-' + Date.now(); }
  }
  function pickVariant() {
    if (cfg.variant === 'A' || cfg.variant === 'B') return cfg.variant;
    var st = readState();
    if (st.variant === 'A' || st.variant === 'B') return st.variant;
    var v = Math.random() < 0.5 ? 'A' : 'B';
    writeState({ variant: v });
    return v;
  }
  function shouldShow() {
    var st = readState();
    if (st.submitted) return false;
    if (st.dismissedAt && Date.now() - st.dismissedAt < COOLDOWN_DAYS * 864e5) return false;
    if (/\/(cart|checkout|account)/.test(location.pathname)) return false;
    return true;
  }

  /* ---------------- persistent teaser ---------------- */
  // The teaser is present at all times when the popup is closed (and on first
  // load), so a visitor can always re-open the game. It hides while the popup
  // is open and is removed permanently once the offer is claimed.
  function teaserAllowed() {
    if (readState().submitted) return false;
    if (/\/(cart|checkout|account)/.test(location.pathname)) return false;
    return true;
  }
  function showTeaser() {
    if (!teaserAllowed()) return;
    if (teaserEl) { teaserEl.style.display = ''; teaserEl.classList.add('is-visible'); return; }

    // Keep the original, long-running bandit teaser exactly as rendered by the
    // live popup. Clone it only to replace the legacy click handler on game-arm
    // visits; this preserves its dynamic copy, format class and native styling.
    var original = document.getElementById('rw-popup-teaser');
    if (!original) return;
    teaserEl = original.cloneNode(true);
    teaserEl.id = 'rw-popup-teaser';
    original.parentNode.replaceChild(teaserEl, original);
    teaserEl.style.display = '';
    teaserEl.classList.add('is-visible');
    teaserEl.addEventListener('click', function () {
      if (currentRoot && document.body.contains(currentRoot)) return;
      if (!teaserAllowed()) return;
      open(currentVariant);
    });
  }
  function hideTeaser() {
    if (teaserEl) teaserEl.classList.remove('is-visible');
  }
  function removeTeaser() {
    if (teaserEl) { try { teaserEl.remove(); } catch (_) {} teaserEl = null; }
  }

  /* ---------------- tracking ---------------- */
  function post(path, payload) {
    if (!cfg.apiBase) return Promise.resolve(null);
    return fetch(cfg.apiBase + '/' + path, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        apikey: cfg.anonKey || '',
        Authorization: 'Bearer ' + (cfg.anonKey || '')
      },
      body: JSON.stringify(payload)
    }).then(function (r) { return r.json().catch(function () { return null; }); })
      .catch(function () { return null; });
  }
  function track(event, v, extra) {
    var payload = {
      event: event,
      variant: v.key,
      popup_id: POPUP_ID,
      popup_name: 'Tap the spot (' + v.key + ')',
      page: location.pathname,
      session_id: sessionId()
    };
    for (var k in (extra || {})) payload[k] = extra[k];
    return post('popup-event', payload);
  }
  function trackChoice(v, spotId, correct) {
    return post('behavr-event', {
      event: 'quiz_choice',
      session_id: sessionId(),
      impression_id: (window.RoundwayBandit && window.RoundwayBandit.impressionId) || null,
      tag: v.key.toLowerCase() + ':' + spotId + (correct ? ':correct' : ':wrong')
    });
  }

  /* ---------------- anatomy ---------------- */
  /* Real anatomical illustration + percentage-positioned hotspots.
     Coordinates are % of the artwork box (viewer's left = body's right). */
  var IMAGE = cfg.image || '/shopify-theme/assets/roundway-anatomy-torso.png';

  function figureFor(v) {
    var spots = v.spots.map(function (s) {
      var side = s.side === 'right' ? 'rwg-s-right' : 'rwg-s-left';
      return '<button class="rwg-spot ' + side + '" type="button" data-spot="' + s.id + '"' +
        ' style="left:' + s.at[0] + '%;top:' + s.at[1] + '%" aria-label="' + s.label + '">' +
        '<span class="rwg-dot"></span>' +
        '<span class="rwg-tag">' + s.label + '</span>' +
        '</button>';
    }).join('');

    var swimmer = v.correct === 'gut'
      ? '<span class="rwg-swimmer" aria-hidden="true"><svg viewBox="0 0 40 24" width="40" height="24">' +
          '<circle cx="12" cy="12" r="6" class="rwg-cell"></circle>' +
          '<circle cx="24" cy="9" r="4" class="rwg-cell"></circle>' +
          '<circle cx="28" cy="17" r="3" class="rwg-cell"></circle>' +
        '</svg></span>'
      : '<span class="rwg-swimmer" aria-hidden="true"><svg viewBox="0 0 44 20" width="44" height="20">' +
          '<path class="rwg-worm" d="M2 10c5-7 9 7 14 0s9 7 14 0 8 3 12 0"></path>' +
          '<circle class="rwg-worm-head" cx="41" cy="10" r="3"></circle>' +
        '</svg></span>';

    return '<div class="rwg-figure">' +
      '<img class="rwg-anatomy-img" src="' + IMAGE + '" alt="Anatomical illustration of the digestive system" width="768" height="1024">' +
      spots + swimmer +
      '</div>';
  }

  /* Animate the swimmer from the tapped spot to the correct spot along a curve. */
  function swim(root, v, fromId, cb) {
    var fig = root.querySelector('.rwg-figure');
    var el = root.querySelector('.rwg-swimmer');
    var byId = {};
    v.spots.forEach(function (s) { byId[s.id] = s.at; });
    var a = byId[fromId], b = byId[v.correct];
    if (!fig || !el || !a || !b || a === b && fromId === v.correct) {
      if (a && el) { el.style.left = a[0] + '%'; el.style.top = a[1] + '%'; el.classList.add('rwg-swim-on'); }
      setTimeout(cb, fromId === v.correct ? 700 : 0);
      return;
    }
    var cx = (a[0] + b[0]) / 2 + (b[1] > a[1] ? -12 : 12);
    var cy = (a[1] + b[1]) / 2 + 6;
    var dur = 1500, t0 = null;
    el.classList.add('rwg-swim-on');
    function frame(ts) {
      if (t0 === null) t0 = ts;
      var t = Math.min(1, (ts - t0) / dur);
      var e = t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
      var x = (1 - e) * (1 - e) * a[0] + 2 * (1 - e) * e * cx + e * e * b[0];
      var y = (1 - e) * (1 - e) * a[1] + 2 * (1 - e) * e * cy + e * e * b[1];
      el.style.left = x + '%';
      el.style.top = y + '%';
      var ang = Math.atan2(b[1] - a[1], b[0] - a[0]) * 180 / Math.PI;
      el.style.setProperty('--rwg-angle', ang.toFixed(1) + 'deg');
      if (t < 1) requestAnimationFrame(frame); else setTimeout(cb, 260);
    }
    requestAnimationFrame(frame);
  }



  function build(v) {
    var discountUrl = 'https://roundwaysupplements.com/discount/' + encodeURIComponent(cfg.discountCode) + '?redirect=/collections/all';
    var root = document.createElement('div');
    root.className = 'rwg-root rwg-variant-' + v.key.toLowerCase();
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-modal', 'true');
    root.innerHTML =
      '<div class="rwg-scrim" data-close="1"></div>' +
      '<div class="rwg-wrap"><div class="rwg-modal">' +
        '<div class="rwg-viz">' +
          '<div class="rwg-mark">Roundway</div><div class="rwg-rule"></div>' +
          '<div class="rwg-body">' + figureFor(v) + '</div>' +
          '<p class="rwg-hint">' + v.hint + '</p>' +
        '</div>' +
        '<div class="rwg-panel">' +
          '<p class="rwg-eyebrow">one click</p>' +
          '<h2>' + v.title + '</h2>' +
          '<p class="rwg-sub">' + v.sub + '</p>' +
          '<div class="rwg-reveal">' +
            '<p class="rwg-verdict"></p>' +
            '<p class="rwg-fact">' + v.fact + '</p>' +
            '<div class="rwg-stat"><strong>' + v.stat.big + '</strong><span>' + v.stat.small + '</span></div>' +
          '</div>' +
          '<form class="rwg-form" novalidate>' +
            '<label for="rwg-email">' + v.formLabel + '</label>' +
            '<input id="rwg-email" type="email" inputmode="email" autocomplete="email" placeholder="you@email.com" required>' +
            '<p class="rwg-offerline">Mystery code inside. Magnesium pack on us over £25.</p>' +
            '<button class="rwg-btn" type="submit">' + v.cta + '</button>' +
            '<p class="rwg-err" aria-live="polite"></p>' +
            '<a class="rwg-link" href="#" data-close="1">' + v.skip + '</a>' +
            '<p class="rwg-fine">Made in the UK · One email, then our usual notes. Unsubscribe any time.</p>' +
          '</form>' +
          '<div class="rwg-done">' +
             '<h3>' + v.doneTitle + '</h3>' +
             '<h4>Here is what was inside.</h4>' +
             '<p>Use it at checkout for <span data-rw-pct>10%</span> off your first order. Or tap below \u2014 we\u2019ll apply it for you.</p>' +
             '<div class="rwg-code"><strong>' + cfg.discountCode + '</strong>' +
              '<button type="button" class="rwg-copy" data-code="' + cfg.discountCode + '">Copy</button></div>' +
             '<a class="rwg-btn" href="' + discountUrl + '">Start shopping, <span data-rw-pct>10%</span> applied<span aria-hidden="true">\u2192</span></a>' +
            '<p class="rwg-trust">Made in the UK · Magnesium Pack On Us Over £25 · Shipping On Us Over £34</p>' +
          '</div>' +
        '</div>' +
      '</div></div>';
    return root;
  }


  function open(v) {
    currentVariant = v;
    hideTeaser();
    var root = build(v);
    currentRoot = root;
    document.body.appendChild(root);
    requestAnimationFrame(function () { root.classList.add('rwg-open'); });
    track('view', v);
    writeState({ variant: (v === VARIANTS.A ? 'A' : 'B'), lastShownAt: Date.now() });

    function close(dismissed) {
      if (dismissed) {
        writeState({ dismissedAt: Date.now() });
        track('dismiss', v);
      }
      root.classList.remove('rwg-open');
      setTimeout(function () {
        try { root.remove(); } catch (_) {}
        currentRoot = null;
        if (teaserAllowed()) showTeaser();
      }, 180);
    }

    root.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('[data-close]') : null;
      if (t) { e.preventDefault(); close(true); return; }
      var hot = e.target.closest ? e.target.closest('.rwg-spot') : null;
      if (hot && !root.classList.contains('rwg-answered')) answer(hot.getAttribute('data-spot'));
    });
    root.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var hot = e.target.closest ? e.target.closest('.rwg-spot') : null;
      if (hot && !root.classList.contains('rwg-answered')) { e.preventDefault(); answer(hot.getAttribute('data-spot')); }
    });
    document.addEventListener('keydown', function onKey(e) {
      if (e.key === 'Escape' && document.body.contains(root)) { close(true); document.removeEventListener('keydown', onKey); }
    });

    function answer(spotId) {
      var correct = spotId === v.correct;
      root.querySelectorAll('.rwg-spot').forEach(function (el) {
        if (el.getAttribute('data-spot') === spotId) el.classList.add('rwg-is-picked');
        el.disabled = true;
      });
      root.classList.add('rwg-swimming');
      trackChoice(v, spotId, correct);

      swim(root, v, spotId, function () {
        root.classList.remove('rwg-swimming');
        root.classList.add('rwg-answered');
        root.querySelectorAll('.rwg-spot').forEach(function (el) {
          var isRight = el.getAttribute('data-spot') === v.correct;
          el.classList.add(isRight ? 'rwg-is-correct' : 'rwg-is-wrong');
        });
        var verdict = correct ? v.verdictRight
          : (spotId === 'stomach') ? v.verdictWrong : v.verdictOther;
        root.querySelector('.rwg-verdict').textContent = verdict;
        var input = root.querySelector('#rwg-email');
        var isMobile = window.matchMedia('(max-width:760px)').matches;
        if (!isMobile) setTimeout(function () { try { input.focus({ preventScroll: true }); } catch (_) {} }, 240);
        var target = isMobile ? root.querySelector('.rwg-form') : root.querySelector('.rwg-reveal');
        setTimeout(function () {
          try { target.scrollIntoView({ behavior: 'smooth', block: isMobile ? 'center' : 'nearest' }); } catch (_) {}
        }, isMobile ? 120 : 0);
      });
    }

    root.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('.rwg-copy');
      if (!b) return;
      try { navigator.clipboard.writeText(b.getAttribute('data-code')); } catch (_) {}
      b.textContent = 'Copied';
      setTimeout(function () { b.textContent = 'Copy'; }, 1800);
    });


    root.querySelector('.rwg-form').addEventListener('submit', function (e) {
      e.preventDefault();
      var input = root.querySelector('#rwg-email');
      var err = root.querySelector('.rwg-err');
      var btn = root.querySelector('.rwg-form .rwg-btn');
      var email = (input.value || '').trim().toLowerCase();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { err.textContent = 'That email doesn\u2019t look right.'; return; }
      err.textContent = '';
      btn.disabled = true; btn.textContent = 'Sending\u2026';
      rwReveal(root, email).then(function () { return track('submit', v, { email: email, tags: v.tags }); }).then(function () {
        writeState({ submitted: true, submittedAt: Date.now() });
        root.classList.add('rwg-done-state');
        removeTeaser();
      }).catch(function () {
        btn.disabled = false; btn.textContent = v.cta;
        err.textContent = 'Something went wrong. Try again?';
      });
    });
  }

  /* ---------------- boot ---------------- */
  // Gated on the bandit's 50/50 split. Only fires when the bandit picked the
  // 'game' arm (RoundwayBandit.format === 'game'). If the bandit is absent or
  // picks 'standard', the game stays dormant and the legacy popup runs — no
  // double popup.
  function start(arm) {
    if (arm !== 'game') return;
    var v = VARIANTS[pickVariant()];
    currentVariant = v;
    // Teaser is present from first load and after every close — it is the
    // persistent re-open path. Auto-open still respects shouldShow().
    if (teaserAllowed()) showTeaser();
    if (!shouldShow()) return;
    var fired = false;
    function go() { if (!fired) { fired = true; open(v); } }
    setTimeout(go, cfg.delay);
    document.addEventListener('mouseleave', function (e) { if (e.clientY <= 0) go(); });
    var scrolled = false;
    window.addEventListener('scroll', function () {
      if (scrolled) return;
      var h = document.documentElement.scrollHeight - window.innerHeight;
      if (h > 0 && window.scrollY / h > 0.45) { scrolled = true; go(); }
    }, { passive: true });
  }
  function boot() {
    if (!window.RoundwayBandit || !window.RoundwayBandit.ready) {
      // Scripts can be deferred or reordered by Shopify/app optimisers. Retry
      // briefly instead of silently abandoning the game arm for this page.
      var attempts = 0;
      var waitForBandit = setInterval(function () {
        attempts++;
        if (window.RoundwayBandit && window.RoundwayBandit.ready) {
          clearInterval(waitForBandit);
          boot();
        } else if (attempts >= 20) {
          clearInterval(waitForBandit);
        }
      }, 50);
      return;
    }
    // The split is local and synchronous. Start the game immediately rather
    // than waiting for the remote analytics decision on slow mobile networks.
    if (window.RoundwayBandit.splitArm) {
      start(window.RoundwayBandit.splitArm);
      return;
    }
    window.RoundwayBandit.ready.then(function (res) {
      start(res && res.format);
    });
  }

  window.RoundwayPopupGame = { open: function (which) { open(VARIANTS[which || pickVariant()]); }, variants: VARIANTS };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
